import basic from '../basic/pt'
export default {
    ...basic,
    ...{
        meta : {
            title : "Gerador de imagens AI gratuito: texto para imagem online; Troca de rosto online grátis",
            keywords : "Troca de rosto, Deepfake, Gerador de imagem AI, Troca de rosto de vídeo,",
            description : "Produza imagens e arte geradas por IA com um prompt de texto, troca de rosto de fotos e vídeos com IA de alta qualidade on-line, crie qualquer imagem que você possa imaginar com o gerador de imagens Beauty AI.",
        },        
        textimghomeindex : {
            titlebefore : 'Arte de IA',
            titleafter : "Gerador inspirado na sua ideia",
            subtitle : "Crie imagens incríveis a partir de texto em segundos. Transforme sua inspiração em realidade.",
            buttontext : 'Teste grátis agora',
        },
        faceswaphomeindex : {
            titlebefore : 'Foto e vídeo',
            titleafter : 'trocas de rosto',
            subtitle : 'Quer saber se a IA pode trocar o rosto em vídeo e foto? Experimente agora e você obterá resultados excelentes de troca de rosto em um minuto com um clique.',
            buttontext : 'Troca de rosto agora',
        },
        showcasehomeindex : {
            title : 'Imagens geradas por IA',
            buttontext : 'Teste grátis agora',
            hovertitle : 'Tente este prompt',
        },
        introducehomeindex : {
            item1title : 'Personalize suas imagens de arte AI',
            item1subtitle : "Beauty AI es un generador de imágenes de Al Art que te permite crear creaciones de animación en todos los estilos. Decide tu inspiración, descríbela rápidamente y conviértela en imágenes de anime. ¡Recuerda que tus creaciones te pertenecen mientras haces tu alma gemela con el personaje de anime único!",
            item1buttontext : 'Teste grátis agora',
            item2title : 'Gere uma verdadeira alma gêmea com inspiração',
            item2subtitle : 'Como um gerador de imagens AI fácil de usar, nosso objetivo é realizar o seu sonho com grande esforço. Descreva a garota dos seus sonhos com palavras simples e nós geraremos sua arte em segundos!',
            item2buttontext : 'Teste grátis agora',
        
        },        
    },
}